'use client';

import Close from '../x.svg';

import Image from 'next/image';

import { useState } from 'react';
import Link from 'next/link';

export default function NavMenu() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="font-[900] static text-gray-900"
        onClick={() => setIsOpen(!isOpen)}
      >
        MENU
      </div>
      <div
        className={`fixed w-full h-full bg-white z-[9999] flex gap-8 flex-col p-8 top-0 left-0 ${
          isOpen ? 'block' : 'hidden'
        }`}
      >
        <div
          className="absolute top-6 right-6 cursor-pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Image src={Close} alt="Close menu" width={24} height={24} />
        </div>

        <Link
          href="/about"
          className="text-xl block font-[900] text-gray-900"
          onClick={() => setIsOpen(!isOpen)}
        >
          ABOUT
        </Link>
        <Link
          href="/social"
          className="text-xl block font-[900] text-gray-900"
          onClick={() => setIsOpen(!isOpen)}
        >
          SOCIAL
        </Link>

        <Link
          href="/music"
          className="text-xl block font-[900] text-gray-900"
          onClick={() => setIsOpen(!isOpen)}
        >
          MUSIC
        </Link>
        <Link
          href="/videos"
          className="text-xl block font-[900] text-gray-900"
          onClick={() => setIsOpen(!isOpen)}
        >
          VIDEOS
        </Link>
        <Link
          href="/shows"
          className="text-xl block font-[900] text-gray-900"
          onClick={() => setIsOpen(!isOpen)}
        >
          SHOWS
        </Link>
      </div>
    </>
  );
}
